export default {
  modal: 'confirm-modal',
  modalTitle: 'confirm-title',
  modalDescription: 'confirm-description',
  closeIcon: 'confirm-close-icon',
  confirmButton: 'confirm-button',
};
